
<template>
    <div id="FamilyChart" class="f3"></div>
</template>

<script>
import f3 from "family-chart";
import '../../../../sass/_family-chart.scss';
import { dateFormat } from '../constants';
    
export default {
    mounted() {
        const store = f3.createStore({
            data: this.data,
            node_separation: 250,
            level_separation: 150
        }),
        view = f3.d3AnimationView({
            store,
            cont: document.querySelector("#FamilyChart")
        }),
        Card = f3.elements.Card({
            store,
            svg: view.svg,
            card_dim: { w:220,h:70,text_x:75,text_y:15,img_w:60,img_h:60,img_x:5,img_y:5 },
            card_display: [
                d => `${d.data['name']}`,
                d => `${moment(d.data['birthday']).format(dateFormat)}`
            ],
            mini_tree: true,
            link_break: false
        })

        view.setCard(Card)
        store.setOnUpdate(props => view.update(props || {}))
        store.update.tree({initial: true})
    },
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
};
</script>